module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component.css
// module id = ./src/app/Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component.css
// module chunks = main